// extracted by mini-css-extract-plugin
module.exports = {"card":"ShareAskCard_card__v0U0U","actions":"ShareAskCard_actions__60jIq"};